// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LowerContainer_Wrapper__1u1Do","Line":"LowerContainer_Line__5pCaY","Heading":"LowerContainer_Heading__3oZQt"};